// updated 20260517
//动态版本增加
//第二页开始需要加上data-transition-active="true"

//根据提交的表单查询商品
var baseUrl = 'https://wv.valthea.com/20204';

var diamondFlow = new URLSearchParams(window.location.search).get('flow');
var useRingDiamondConstraint = diamondFlow === 'ring-first' || diamondFlow === 'modify-diamond';
if (!useRingDiamondConstraint) {
    sessionStorage.removeItem('wooSpecData');
    localStorage.removeItem('wooSpecData');
}

var filterAttr = {
    "clarity_slider":["VS2","VS1","VVS2","VVS1","IF+FL"],
    "cut_slider":["Ideal+Excellent","Very Good","Good","Fair"],
    "color_slider":["D","E","F","G","H","I","J"]
};
// 跨平台兼容配置
const config = {
    threshold: 100,          // 触底阈值(px)
    maxPullDown: 150,        // 最大下拉距离(px)
    debounceTime: 200,       // 防抖时间(ms)
    isMobile: /Mobi|Android|iPhone/i.test(navigator.userAgent)
};

// 状态管理
const state = {
    page: 0,
    isLoading: false,
    startY: 0,
    isRefreshing: false,
    lastScrollTime: 0
};


var wooviewParamsObject = {};

// DOM元素
const container = document.querySelector("[data-body-wrapper]");
const content = container.querySelector("[data-body-grid]");
const loading = document.getElementById('loading');
const refreshIndicator = document.getElementById('refreshIndicator');

function showLoading() {
    if (!loading) return;
    loading.classList.toggle('is-initial', !content || content.children.length === 0);
    loading.classList.add('is-active');
}

function hideLoading() {
    if (!loading) return;
    loading.classList.remove('is-active');
    loading.classList.remove('is-initial');
}

// 初始化内容
function initContent() {
    wooviewInitNavigation();
    addItem();
    state.page++;

}
function renderDiamondGridHtml(paramsObject){
    if(paramsObject){
        wooviewParamsObject = paramsObject;
    }

    refreshData();
}
async function fetchProducts(callback) {
    const url = baseUrl+'/store/product/diamond/list';
    wooviewParamsObject.page = state.page;
    wooviewParamsObject.shopDomain="https://"+Shopify.shop;
    wooviewParamsObject.productType = 2;
    const clientFancyColors = wooviewParamsObject._clientFancyColors;
    const clientExcludeFancy = wooviewParamsObject.excludeFancy;
    delete wooviewParamsObject._clientFancyColors;
    delete wooviewParamsObject.excludeFancy;
    showLoading();
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(wooviewParamsObject)
        });
        wooviewParamsObject._clientFancyColors = clientFancyColors;
        wooviewParamsObject.excludeFancy = clientExcludeFancy;
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const responseData = await response.json();
        callback(responseData);
    } catch (error) {
        wooviewParamsObject._clientFancyColors = clientFancyColors;
        wooviewParamsObject.excludeFancy = clientExcludeFancy;
        console.error('POST request error:', error);
        throw error;
    } finally {
        hideLoading();
    }
}


// 添加项目元素
function addItem() {
    fetchProducts(function(data){
    if(data && data.content.length > 0){

// ✅ 新增：如果选了 White（非彩色钻石），过滤掉彩色钻石
    if(wooviewParamsObject._clientFancyColors !== undefined && 
   (wooviewParamsObject._clientFancyColors.length > 0 || wooviewParamsObject.excludeFancy)){
    data.content = data.content.filter(function(p){
        // 如果选了 White，只保留无彩色钻石（fancyColor 为空）
        if(wooviewParamsObject.excludeFancy){
            return !p.fancyColor || p.fancyColor.trim() === '';
        }
        // 彩色钻石：fancyColor 非空 且 name 包含颜色词
        if(!p.fancyColor || p.fancyColor.trim() === '') return false;
        return wooviewParamsObject._clientFancyColors.some(function(fc){
            return p.name && p.name.toLowerCase().includes(fc.toLowerCase());
        });
    });
}


        var html = "";
        data.content.forEach(function(item, i){


                if((i + 1) % 8 === 0 && blocks && blocks.length>0){
                    var block = blocks[0];
                    var title = "";
                    if(block.title){
                        title = block.title;
                    }
                    var image = "";
                    if(block.image){
                        image = `<picture class="image--root " data-background="false" data-display-type="fill-available"
	data-full-width="" data-mobile-display-type="fill-available" data-mobile-full-width=""
	data-mobile-overlay-style="darken-bottom" data-parallax="false" data-overlay-style="darken-bottom"
	style="--aspect-ratio:0.8333;--mobile-aspect-ratio:0.8333;">
		<img src="${block.image}&amp;width=1665"
		alt="" srcset="${block.image}&amp;width=200 200w, ${block.image}&amp;width=300 300w, ${block.image}&amp;width=400 400w, ${block.image}&amp;width=500 500w, ${block.image}&amp;width=600 600w, ${block.image}&amp;width=700 700w, ${block.image}&amp;width=800 800w, ${block.image}&amp;width=900 900w, ${block.image}&amp;width=1000 1000w, ${block.image}&amp;width=1200 1200w, ${block.image}&amp;width=1400 1400w, ${block.image}&amp;width=1600 1600w"
		width="1665" height="1998" loading="lazy" sizes="(max-width: 767px) calc(100vw - 32px), calc(100vw - 96px)">
	</picture>`;
                    }
                    var description = "";
                    if(block.description){
                        description = block.description;
                    }
                    var link_a = "";
                    if(block.link_url){
                        link_a = `<a class="stacked-text--button" href="${block.link_url}" data-item="button" data-text="${block.link_text}"
			data-transition-item="grid-promo-1" data-transition-active="true" data-transition-type="fade-in" data-transition-button="">
				<span>
					${block.link_text}
				</span>
			</a>`;
                    }
                    html+=`<div class="collection-promo--root" data-transition-active="true" data-promo-width="4"
data-background-color="none" data-border-type="none" >
	${image}
	<div class="stacked-text--root" data-text-color="body" data-mobile-y-alignment="center"
	data-x-alignment="center" data-y-alignment="center" data-width="medium">
		<div class="stacked-text--wrapper" data-text-style="none" data-transition-active="true" data-background-color="transparent"
		data-translucent="true" data-container="block" 
		data-transition-type="slide-in" data-transition-cascade="vertical" data-transition-cascade-interval="500">
			<div data-transition-item="grid-promo-1">
				<h2 class="stacked-text--title" data-item="section-heading">
					${title}
				</h2>
			</div>
			<div class="stacked-text--description" data-item="featured-paragraph"
			data-transition-item="grid-promo-1">
				<p>
					${description}
				</p>
			</div>
			${link_a}
		</div>
	</div>
</div>`;
                    blocks.splice(0, 1);
                }else{
                    var bodyGrid = document.querySelector("[data-body-grid]");
                    var columns = "4";
                    var color = "";
                    if(item.fancyColor && item.fancyColor.length>0){
                        color = item.fancyColor
                    }else if(item.color){
                        color = item.color
                    }

                    var price =Intl.NumberFormat("en-US", {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(item.price);


                    if(parseInt(columns)==2){
                        content.classList.add("block-content");
                        var bgAlt = "";
                        if (i % 2 !== 0) {
                            bgAlt = 'bg-alt';
                        }
                        //列表
                        html+=`<div data-testid="mendes-diamond-table-row" class="vo-table-row cursor-pointer hover:bg-[#15151526] ${bgAlt}">
	<a class="vo-table-row-head border-b border-content-primary-lowest block"
	href="/products/${item.urlHandle}">
		<div class="sm:mendes-container ml-5 sm:mx-auto grid grid-cols-5 md:grid-cols-6 pl-4 pr-4">
			<div class="vo-table-cell min-h-[50px] items-center md:flex-1 mendes body-s md:title-m hidden md:flex">
				<span class="flex-[0_0_20px] justify-center text-center hidden md:flex">
					<!--<div class="relative right-5">
						<img alt="round-brilliant diamond" width="20" height="20" loading="lazy"
						src="https://www.datocms-assets.com/25216/1722939924-round-hover.svg" style="object-fit: contain;">
					</div>-->
				</span>
				<span class="tablet-and-up">
					${item.name}
				</span>
				&nbsp;
			</div>
			<div class="vo-table-cell min-h-[50px] flex items-center md:flex-1 mendes body-s md:title-m md:justify-center flex-1">
				<span class="flex flex-[0_0_20px] justify-center text-center md:hidden">
					<!--<div class="relative right-5">
						<img alt="round-brilliant diamond" width="20" height="20" loading="lazy"
						src="https://www.datocms-assets.com/25216/1722939924-round-hover.svg" style="object-fit: contain;">
					</div>-->
				</span>
				<span class="flex flex-col items-start md:items-center w-full">
					${item.carat}
					<span class="text-sm md:text-lg font-medium text-left md:text-center w-[200%] md:w-3/4">
					</span>
				</span>
				&nbsp;
			</div>
			
			<div class="vo-table-cell min-h-[50px] flex items-center md:flex-1 mendes body-s md:title-m justify-center text-center flex-1">
				<span class="hidden max-[990px]:block lg:hidden text-center">
					${color}
				</span>
				<span class="max-[990px]:hidden lg:block">
					${color}
				</span>
				&nbsp;
				<div class="flex flex-col">
					<span data-testid="diamond-color-wrapper" class="mendes body-s md:title-m justify-center lg:block max-[990px]:hidden">
						- Colorless
					</span>
				</div>
			</div>
			<div class="vo-table-cell min-h-[50px] flex items-center md:flex-1 mendes body-s md:title-m justify-center text-center flex-1">
				<span class="mobile-only text-center">
					${item.cut}
				</span>
				<span class="tablet-and-up">
					${item.cut}
				</span>
				&nbsp;
			</div>
			<div class="vo-table-cell min-h-[50px] flex items-center md:flex-1 mendes body-s md:title-m justify-center text-center flex-1">
				${item.clarity}&nbsp;
			</div>
			<div class="vo-table-cell min-h-[50px] flex items-center md:flex-1 mendes body-s md:title-m justify-end ml-[-20px] flex-1">
				$${price}&nbsp;
			</div>
		</div>
	</a>
</div>`;
                    }else{
                        content.classList.remove("block-content");
                        var transitionActive = 'data-transition-active="true"';
                        /*if(i==0){
                            transitionActive='';
                        }*/
                        var hoverImage = '';

                        if(item.pictures){
                            var pictures = item.pictures.split(",");
                            hoverImage = pictures.length>1?pictures[1]:pictures[0];
                            if(!item.imageUrl){
                                item.imageUrl = pictures[0];
                            }
                        }
                        var productTitle = ValtheaCollectionCards.escapeHtml(item.name);
                        html += `<div class="product-card--root valthea-enhanced-card" ${transitionActive} data-handle="${item.urlHandle}" data-product-item="" data-text-layout="center" data-container="block" data-aspect-ratio="square" data-transition-item="template--w24075745886242__main">
                  ${ValtheaCollectionCards.renderMedia(item, hoverImage, 'diamond')}

                  <div class="product-card--details">
                    <div class="product-card--details-wrapper"><a href="/products/${item.urlHandle}" class="product-card--title-link">
                        <p class="product-card--title" data-item="paragraph" title="${productTitle}">${productTitle}</p>
                      </a></div><div class="product--price-container">
                  <div class="product--price-wrapper"><span class="product--price" data-item="nav-text">$${price}</span>
                  </div></div><ul data-testid="diamond-attributes" class="md:flex gap-x-sm">
                  <li class="flex">
                    <div class="sc-dd67cf49-0 cenSep mendes md:text-content-primary-mid text-content-primary-mid md-body-m body-m mr-[4px]">Color</div>
                    <div class="sc-dd67cf49-0 cenSep mendes md:text-content-primary-high text-content-primary-high md-body-m body-m">${color}</div>
                  </li>
                  <li class="flex">
                    <div class="sc-dd67cf49-0 cenSep mendes md:text-content-primary-mid text-content-primary-mid md-body-m body-m mr-[4px]">Clarity</div>
                    <div class="sc-dd67cf49-0 cenSep mendes md:text-content-primary-high text-content-primary-high md-body-m body-m">${item.clarity}</div>
                  </li>
                  <li class="flex">
                    <div class="sc-dd67cf49-0 cenSep mendes md:text-content-primary-mid text-content-primary-mid md-body-m body-m mr-[4px]">Cut</div>
                    <div class="sc-dd67cf49-0 cenSep mendes md:text-content-primary-high text-content-primary-high md-body-m body-m">${item.cut}</div>
                  </li>
                </ul></div>
                  ${ValtheaCollectionCards.renderCta(item)}
                </div>`;
                    }

                }

            });
            content.insertAdjacentHTML('beforeend', html);
        }else{
            return;
        }
    });


   // content.appendChild(html);
    //content.removeAttribute("style");
    
}

// 防抖函数
function debounce(fn, delay) {
    let timer = null;
    return function() {
        clearTimeout(timer);
        timer = setTimeout(() => fn.apply(this, arguments), delay);
    };
}

// 加载更多数据
function loadMoreData() {
    if (state.isLoading) return;

    state.isLoading = true;

    setTimeout(() => {
        addItem();

    state.page++;
    state.isLoading = false;
}, 800);
}

// 触底检测逻辑
function checkScroll() {
    const now = Date.now();
    if (now - state.lastScrollTime < config.debounceTime) return;
    state.lastScrollTime = now;

    const { scrollTop, clientHeight, scrollHeight } = container;
    if (scrollTop + clientHeight >= scrollHeight - config.threshold) {
        loadMoreData();
    }
}

// 鼠标滚轮事件处理(PC端)
function handleWheel(e) {
    if (e.deltaY > 0) checkScroll();
}

// 触摸事件处理(移动端)
function handleTouchStart(e) {
    if (container.scrollTop === 0) {
        state.startY = e.touches[0].clientY;
    }
}

function handleTouchMove(e) {
    if (container.scrollTop === 0 && !state.isRefreshing) {
        const currentY = e.touches[0].clientY;
        const diff = currentY - state.startY;

        if (diff > 0) {
            e.preventDefault();
            const progress = Math.min(diff, config.maxPullDown);
            //refreshIndicator.textContent = progress > 100 ? '释放刷新 ↑' : '下拉刷新 ↓';
            refreshIndicator.style.transform = `translateY(${progress}px)`;
        }
    }
}

function handleTouchEnd() {
    const currentY = parseInt(refreshIndicator.style.transform.match(/\d+/));
    if (container.scrollTop === 0 && currentY > 100) {
        refreshData();
    } else {
        refreshIndicator.style.transform = 'translateY(-100%)';
    }
}

// 刷新数据
function refreshData() {
    if (state.isRefreshing) return;

    state.isRefreshing = true;
    //refreshIndicator.textContent = '刷新中...';
    showLoading();
    setTimeout(() => {
        content.innerHTML = '';
    state.page = 0;
    initContent();
    //refreshIndicator.textContent = '刷新完成 ✓';
    setTimeout(() => {
        refreshIndicator.style.transform = 'translateY(-100%)';
    state.isRefreshing = false;
}, 500);
}, 500);
}

// 事件监听
function setupListeners() {
    // 公共事件
    container.addEventListener('scroll', debounce(checkScroll, config.debounceTime));

    // 平台特定事件
    if (config.isMobile) {
        container.addEventListener('touchstart', handleTouchStart);
        container.addEventListener('touchmove', handleTouchMove);
        container.addEventListener('touchend', handleTouchEnd);
    } else {
        container.addEventListener('wheel', handleWheel);
       // refreshIndicator.textContent = '↓ 点击刷新';
       // refreshIndicator.addEventListener('click', refreshData);
    }
    $(document).on('click', '.filter__inputs a', function(e) {
        e.preventDefault(); // 阻止默认链接行为
        var checkbox = $(this).find('input[type="checkbox"]');

        if($(this).hasClass("filter_active")){
            $(this).removeClass("filter_active");
            checkbox.prop('checked', false);
        }else{
            $(this).addClass("filter_active");
            checkbox.prop('checked', true);
           if(checkbox.attr('name') === 'shape'){
                var subtext = checkbox.attr('data-subtext');
                if(subtext && subtext.length>0){
                    $("#section_diamond_title").text(subtext);
                }
              
             
            }
        }

        refreshData();
    });

    $(document).on('click', '.btn-search-diamond', function(e) {
        e.preventDefault(); // 阻止默认链接行为
        if ($('#diamond_search_text').val()=="") {
            return false;
        }

        refreshData();
    });
}

function formDataToObject(urlParams) {

    // 获取所有shape参数（处理重复键）
    const shapes = urlParams.getAll('shape'); // 返回数组：["Round Brilliant", "Oval", "Emerald", "Pear"]
    const cuts = urlParams.getAll('cut'); // 返回数组
    const claritys = urlParams.getAll('clarity'); // 返回数组
    const colors = urlParams.getAll('color'); // 返回数组
    const fancyColors = urlParams.getAll("fancyColor");
    let excludeFancy = false;  // 新增
    if(fancyColors.includes("White")){
    excludeFancy = true;  // 改这里
    const idx = fancyColors.indexOf("White");
    fancyColors.splice(idx, 1);
}


// 获取价格范围参数
    const minPrice = urlParams.get('filter.v.price.gte'); // "0.00"
    const maxPrice = urlParams.get('filter.v.price.lte'); // "3497.00"
    const minCarat = urlParams.get('minCarat'); // "0.00"
    const maxCarat = urlParams.get('maxCarat'); // "3497.00"

    const q = urlParams.get('q'); //搜索内容
    const params = {
        minPrice: parseFloat(minPrice),
        maxPrice: parseFloat(maxPrice),
        minCarat: parseFloat(minCarat),
        maxCarat: parseFloat(maxCarat),
        q:q
    };
    if(shapes){
        params.shapes =Array.from(new Set(shapes));
    }
    if(cuts){
        params.cuts =Array.from(new Set(cuts));
    }
    if(claritys){
        params.claritys =Array.from(new Set(claritys));
    }
    if(colors){
        params.colors =Array.from(new Set(colors));
    }
    params.excludeFancy = excludeFancy;
params._clientFancyColors = Array.from(new Set(fancyColors));
return params;



}

function wooviewInitNavigation() {
    var navigation = document.querySelector('.navigation--root');
    var url = navigation.getAttribute("data-url");
   // var filter = document.querySelector("#filter__inputs");
    var t = new FormData();
    $('input[name="shape"]:checked').each(function(index) {
        t.append('shape', $(this).val());
    });
    $('input[name="fancyColor"]:checked').each(function(index) {
        t.append('fancyColor', $(this).val());
    });

    //获取其他属性
    var minCarat = $("#carat2_range_min").val();
    var maxCarat =$("#carat2_range_max").val();
    if(minCarat!=0 || maxCarat!=13.5){
        t.append('minCarat', minCarat);
        t.append('maxCarat', maxCarat);
    }

    var cutStr = $("input[name='cut_slider']").val();
    var clarityStr = $("input[name='clarity_slider']").val();
    var colorStr = $("input[name='color_slider']").val();
    if(cutStr){
        var values = cutStr.split(",");
        if(values.length!==filterAttr['cut_slider'].length){
            for (var i=0;i<values.length;i++){
                t.append('cut', values[i]);
            }
        }

    }
    if(clarityStr){
        var values = clarityStr.split(",");
        if(values.length!==filterAttr['clarity_slider'].length){
            for (var i=0;i<values.length;i++){
                t.append('clarity', values[i]);
            }
        }
    }
    if(colorStr){
        var values = colorStr.split(",");
        if(values.length!==filterAttr['color_slider'].length){
            for (var i=0;i<values.length;i++){
                t.append('color', values[i]);
            }
        }
    }

    var search_text = $('#diamond_search_text').val();
    if(search_text && search_text.length>0){
        t.append('q', search_text);
    }

     var  e = new URLSearchParams(t);
    wooviewParamsObject =formDataToObject(e);
    var ajax_url = `${url}${e.toString()}`;
    history.replaceState({}, "", ajax_url);

}
function normalizeDiamondShape(shape) {
    var normalized = (shape || "").trim().toUpperCase();
    if (normalized === "ROUND" || normalized === "ROUND BRILLIANT") return "ROUND";
    return normalized;
}

function getRingShapeConstraint(wooSpecData) {
    if (!wooSpecData || !wooSpecData.ring) return null;
    var ring = wooSpecData.ring;
    var selectedShape = ring.selectedShape;
    if (!selectedShape && ring.specSku) {
        for (var i = 0; i < ring.specSku.length; i++) {
            var name = (ring.specSku[i].specName || "").trim().toUpperCase();
            if (name === "SHAPE" || name === "DIAMOND SHAPE" || name === "DIAMOND TYPE") {
                selectedShape = ring.specSku[i].specValue;
                break;
            }
        }
    }
    if (!selectedShape) return null;
    var compatibleShapes = ring.compatibleShapes && ring.compatibleShapes.length
        ? ring.compatibleShapes
        : [selectedShape];
    return { selectedShape: selectedShape, compatibleShapes: compatibleShapes };
}

function applyRingShapeConstraint(wooSpecData) {
    var constraint = getRingShapeConstraint(wooSpecData);
    if (!constraint) return false;

    var compatibleKeys = constraint.compatibleShapes.map(normalizeDiamondShape);
    var requestedShapes = wooviewParamsObject.shapes || [];
    var selectedKeys = requestedShapes
        .map(normalizeDiamondShape)
        .filter(function(shape){ return compatibleKeys.indexOf(shape) !== -1; });
    if (selectedKeys.length === 0) selectedKeys = [normalizeDiamondShape(constraint.selectedShape)];

    var selectedValues = [];
    $('input[type="checkbox"][name="shape"]').each(function() {
        var checkbox = $(this);
        var shapeKey = normalizeDiamondShape(checkbox.val());
        var visible = compatibleKeys.indexOf(shapeKey) !== -1;
        var selected = visible && selectedKeys.indexOf(shapeKey) !== -1;
        // The active diamond navigation renders each option as
        // div.flex-col > a > input, rather than li.filter--link.
        var wrapper = checkbox.closest('a');
        var option = wrapper.closest('.flex-col');

        option.toggle(visible);
        checkbox.prop('checked', selected);
        wrapper.toggleClass('filter_active', selected);
        if (selected) selectedValues.push(checkbox.val());
    });
    wooviewParamsObject.shapes = selectedValues;
    return true;
}

function getFilterByUrl() {
    const params = new URLSearchParams(window.location.search);
    wooviewParamsObject =formDataToObject(params);

    var sessionWooSpecData = {};
    var localWooSpecData = {};
    try { sessionWooSpecData = JSON.parse(sessionStorage.getItem("wooSpecData") || "{}"); } catch (e) {}
    try { localWooSpecData = JSON.parse(localStorage.getItem("wooSpecData") || "{}"); } catch (e) {}
    var wooSpecData = Object.assign({}, localWooSpecData, sessionWooSpecData);
    wooSpecData.ring = localWooSpecData.ring || sessionWooSpecData.ring;

    if(useRingDiamondConstraint && applyRingShapeConstraint(wooSpecData)){
        // 戒托约束优先：默认选中已选 Shape，并隐藏不兼容 Shape。
    }else if(wooviewParamsObject.shapes && wooviewParamsObject.shapes.length>0){
        setFilterByUrlChecked("shape",wooviewParamsObject.shapes);
    }
    if(wooviewParamsObject._clientFancyColors && wooviewParamsObject._clientFancyColors.length>0){
        setFilterByUrlChecked("fancyColor",wooviewParamsObject._clientFancyColors);
    }
    //设置其他滑块属性
    $("input[name='cut_slider']").val(wooviewParamsObject.cuts);
    $("input[name='clarity_slider']").val(wooviewParamsObject.claritys);
    $("input[name='color_slider']").val(wooviewParamsObject.colors);

    $('#diamond_search_text').val(wooviewParamsObject.q);
}
function setFilterByUrlChecked(name,lists) {
    var checkboxes = $('input[type="checkbox"][name="'+name+'"]');
    // 遍历处理每个checkbox
    checkboxes.each(function() {
        var val = $(this).val();
        for(var i=0;i<lists.length;i++){
            var item = lists[i];
            if(item==val){
                $(this).prop('checked', true);
                $(this).parent().addClass("filter_active");
            }
        }

    });
}
getFilterByUrl();


// 初始化
//initContent();
setupListeners();


$(function() {



    // 初始化滑块
    function initSlider(eleName,step,initialValues) {
       // const step = parseInt(stepValue);
        var $slider = $("#"+eleName);
        $slider.slider({
            range: true,
            min: 0,
            max: initialValues[1],
            step: step,
            values: initialValues,
            slide: function(event, ui) {
                updateDisplay(eleName,ui.values);
            },
            change: function(event, ui) {
                updateDisplay(eleName,ui.values);
            },
            stop: function(event, ui) {
               // updateDisplay(eleName,ui.values);
                refreshData();
            }
        });

        updateDisplay(eleName,initialValues);
    }

    // 更新显示区域
    function updateDisplay(eleName,values) {
        if(eleName == 'carat_slider'){
            $("#carat2_range_min").val(values[0]);
            $("#carat2_range_max").val(values[1]);
        }else{
            var prev = $("#"+eleName).prev();

            var attr = filterAttr[eleName];
            var vals = [];
            for (var i=values[0];i<values[1];i++){
                vals.push(attr[i]);
            }
            if(vals && vals.length>0){
                prev.val(vals.join(","));
            }

        }
        refreshData();

    }

    initSlider("clarity_slider",1,[0,5]);
    initSlider("color_slider",1,[0,7]);
    initSlider("cut_slider",1,[0,4]);
    initSlider("carat_slider",0.1,[0,15.0]);
});
